import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Initialize i18n with empty resources
// All content will be loaded dynamically from Firestore via ContentContext
i18n
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources: {
      en: { translation: {} },
      bg: { translation: {} },
      de: { translation: {} },
    },
    fallbackLng: "en", // Default to English
    supportedLngs: ["en", "bg", "de"],

    // Set initial language to English
    lng: "en",

    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
